import 'bootstrap';
import 'knockout.validation';
import Numeric from './shared/bindings/numeric';
import ValueWithInit from './shared/bindings/value-with-init.bindings';
import EventTileCarousel from './shared/components/event-tile-carousel.component';
import BootstrapModalComponent from './shared/components/modal.components';
import PageSpinner from './shared/components/page-spinner.component';
import ShoppingCart from './shared/components/shopping-cart.component';
import ValidatorExtension from './shared/extensions/validator.extension';
import { CartInitialiser } from './viewmodel/cart';
import { CheckoutInitialiser } from './viewmodel/checkout';
import { ConfirmationInitialiser } from './viewmodel/confirmation';
import { PayPalConfirmationInitialiser } from './viewmodel/paypal-confirmation';
import { ReturnTicketsInitialiser } from './viewmodel/return-tickets';

// Initialise Components
[
  Numeric,
  ValueWithInit,
  PageSpinner,
  BootstrapModalComponent,
  ShoppingCart,
  EventTileCarousel,
  ValidatorExtension
].forEach((c) => new c());

// Initialise View Models
[
  {
    initialiser: CheckoutInitialiser,
    selector: '.ko-checkout',
  },
  {
    initialiser: PayPalConfirmationInitialiser,
    selector: '.paypal-confirmation'
  },
  {
    initialiser: ConfirmationInitialiser,
    selector: '.tryb-confirmation'
  },
  {
    initialiser: CartInitialiser,
    selector: '.tryb-cart-vm'
  },
  {
    initialiser: ReturnTicketsInitialiser,
    selector: '.tryb-return-tickets'
  }
].forEach(c => {
  if (document.querySelector(c.selector) != null) {
    c.initialiser();
  }
});